import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledAC = styled(StockModelCardHeaderStyled)`
    .stockModelCard-header {
        &--heading {
            min-height: unset;
            color: ${({ theme }) => theme.colors.grey5};
        }
        &--engineInfo {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            color: ${({ theme }) => theme.colors.grey5};
        }
        &--demoInfo {
            color: ${({ theme }) => theme.colors.grey1};
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }
`;
